import { useState, useEffect, useContext } from "react";

import PanelRightContent from "../../layouts/mainPanel/PanelRightContent";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import { ReactComponent as MarketIcon } from "../../asset/icons/sidebar/basket.svg";
import { ReactComponent as PlusIcon } from "../../asset/icons/plusIconLarge.svg";
import { ReactComponent as EditIcon } from "../../asset/icons/editIconBlue.svg";
import ItemCart from "./components/ItemCart";
import BasketInput from "./components/FoodInput";

import { ReactComponent as CubeIcon } from "../../asset/icons/cube.svg";
import { ReactComponent as DateIcon } from "../../asset/icons/calender_gray_s.svg";
import { ReactComponent as CoinIcon } from "../../asset/icons/rate_ic.svg";
import { useParams, useNavigate } from "react-router-dom";

import defaultImage from "./../../asset/image/ex_img_3.png";
import dateIcon from "./../../asset/icons/calender_gray_s.svg";
import feedCoin from "./../../asset/icons/rate_ic.svg";
import starIcon from "./../../asset/icons/starIcon.svg";
import { Spinner } from "react-bootstrap";

import {
    GET_MARKET_BASKET,
    SAVE_MARKET_BASKET,
    DELETE_MARKET_PRICE,
    EDIT_MARKET_PRICE,
    GET_MARKET_ITEMS,
    CREATE_FOOD,
} from "../../helperData/ApiAddress";
import {
    del,
    get,
    patch,
    post,
    put,
} from "../../controlers/global/ConfigRequest";

import { ToastContext } from "../../component/global/ToastContext";
import { EDIT_FOOD, GET_FOOD } from "./../../helperData/ApiAddress";

export default function FoodForm() {
    const { id, item } = useParams();
    const history = useNavigate();

    const [discount, setDiscount] = useState("");
    const [discountErr, setDiscountErr] = useState("");

    const [fee, setFee] = useState("");
    const [feeErr, setFeeErr] = useState("");

    const [deliverFrom, setDeliverFrom] = useState("");
    const [deliverFromErr, setDeliverFromErr] = useState("");

    const [deliverTo, setDeliverTo] = useState("");
    const [deliverToErr, setDeliverToErr] = useState("");

    const [paymentFrom, setPaymentFrom] = useState("");
    const [paymentFromErr, setPaymentFromErr] = useState("");

    const [paymentTo, setPaymentTo] = useState("");
    const [paymentToErr, setPaymentToErr] = useState("");

    const [price, setPrice] = useState("");
    const [priceErr, setPriceErr] = useState("");

    const [feedCoin, setFeedCoin] = useState("");
    const [feedCoinErr, setFeedCoinErr] = useState("");

    const [formLoader, setFormLoader] = useState(false);
    const [loader, setLoader] = useState(false);
    const [priceDeleteLoader, setPriceDeleteLoader] = useState(false);
    const [priceEditLoader, setPriceEditLoader] = useState(false);

    const [priceList, setPriceList] = useState(undefined);
    const [priceListEditMode, setPriceListEditMode] = useState(false);

    const [editItem, setEditItem] = useState(undefined);

    const [itemBox, setItemBox] = useState(undefined);

    const show = useContext(ToastContext);

    const getFormInfo = () => {
        setLoader(true);

        get(GET_FOOD.replace(":id", id))
            .then((r) => {
                setEditItem(r.item);
                setFeedCoin(r.coin + "");
                setPrice(r.price + "");
                setDiscount(r.discount + "");
                setFee(r.fee + "");
            })
            .finally((e) => {
                setLoader(false);
            });
    };

    const getItemInfo = (id) => {
        get(GET_MARKET_ITEMS + id).then((r) => {
            setItemBox(r);
        });
    };

    // const deletePrice = (id, row)=>{
    //     if(id){
    //         setPriceDeleteLoader(id)
    //         del(DELETE_MARKET_PRICE.replace(":id", id)).then(r=>{
    //             setPriceList(priceList.filter(item=>item.id!==id))
    //         })
    //         .finally(_=>{
    //             setPriceDeleteLoader(false)
    //         })
    //     }else{
    //         setPriceList(priceList.filter((item, index)=>index !== row))
    //     }
    // }

    // const goToEdit = (index) => {
    //     setPriceListEditMode(index);
    //     const row = priceList.filter((item, ind)=> index === ind)[0];
    //     // console.log(row);
    //     setVolumeFrom(row.volumeFrom + '');
    //     setVolumeTo(row.volumeTo + '');
    //     setDeliverFrom(row.deliverFrom + '');
    //     setDeliverTo(row.deliverTo + '');
    //     setPaymentFrom(row.paymentFrom + '');
    //     setPaymentTo(row.paymentTo + '');
    //     setPrice(row.price + '');
    // }

    useEffect(() => {
        if (id) {
            getFormInfo();
        }
    }, []);

    useEffect(() => {
        if (item) {
            getItemInfo(item);
        } else if (editItem) {
            getItemInfo(editItem);
        }
    }, [editItem, item]);

    // const priceListHandle = ()=>{

    // if(volumeFrom.trim() === "") {
    //     setVolumeFromErr("لطفا حجم را وارد کنید");
    //     hasErr = true;
    // }
    // else if(!Number.isInteger(volumeFrom.trim() * 1)){
    //     setVolumeFromErr("مقدار حجم نامعتبر است");
    //     hasErr = true;
    // }

    // if(volumeTo.trim() === "") {
    //     setVolumeToErr("لطفا حجم را وارد کنید");
    //     hasErr = true;
    // }
    // else if(!Number.isInteger(volumeTo.trim() * 1)) {
    //     setVolumeToErr("مقدار حجم نامعتبر است");
    //     hasErr = true;
    // }

    // if(deliverFrom.trim() === "") {
    //     setDeliverFromErr("لطفا زمان تحویل را وارد کنید");
    //     hasErr = true;
    // }
    // else if(!Number.isInteger(deliverFrom.trim() * 1)) {
    //     setDeliverFromErr("مقدار زمان تحویل نامعتبر است");
    //     hasErr = true;
    // }

    // if(deliverTo.trim() === "") {
    //     setDeliverToErr("لطفا زمان تحویل را وارد کنید");
    //     hasErr = true;
    // }
    // else if(!Number.isInteger(deliverTo.trim() * 1)) {
    //     setDeliverToErr("مقدار زمان تحویل نامعتبر است");
    //     hasErr = true;
    // }

    // if(paymentFrom.trim() === "") {
    //     setPaymentFromErr("لطفا زمان پرداخت را وارد کنید");
    //     hasErr = true;
    // }
    // else if(!Number.isInteger(paymentFrom.trim() * 1)) {
    //     setPaymentFromErr("مقدار پرداخت نامعتبر است");
    //     hasErr = true;
    // }

    // if(paymentTo.trim() === "") {
    //     setPaymentToErr("لطفا زمان پرداخت را وارد کنید");
    //     hasErr = true;
    // }
    // else if(!Number.isInteger(paymentTo.trim() * 1)) {
    //     setPaymentToErr("مقدار پرداخت نامعتبر است");
    //     hasErr = true;
    // }

    // if(hasErr) return false;

    //     if(priceListEditMode !== false){
    //         const editPromise = new Promise((resolve, reject)=>{
    //             if(priceList[priceListEditMode].id){
    //                 put(EDIT_MARKET_PRICE.replace(":id", priceList[priceListEditMode].id), {
    //                     sale_cart: 1,
    //                     price: price,
    //                     volume_start: volumeFrom,
    //                     volume_end: volumeTo,
    //                     delivery_start: deliverFrom,
    //                     delivery_end: deliverTo,
    //                     payment_start: paymentFrom,
    //                     payment_end: paymentTo
    //                 }).then(_=>{
    //                     resolve();
    //                 })
    //             }else{
    //                 resolve();
    //             }
    //         })
    //         editPromise.then(r=>{
    //             const priceListTemp = [...priceList];
    //             priceListTemp[priceListEditMode] = {
    //                 id: priceList[priceListEditMode].id || undefined,
    //                 volumeFrom,
    //                 volumeTo,
    //                 deliverFrom,
    //                 deliverTo,
    //                 paymentFrom,
    //                 paymentTo,
    //                 price
    //             }
    //             setPriceList(priceListTemp);
    //             setPriceListEditMode(false);
    //             setVolumeFrom("");
    //             setVolumeTo("");
    //             setDeliverFrom("");
    //             setDeliverTo("");
    //             setPaymentFrom("");
    //             setPaymentTo("");
    //             setPrice("");
    //         })

    //     }else{
    //         setPriceList([...priceList, {
    //             volumeFrom,
    //             volumeTo,
    //             deliverFrom,
    //             deliverTo,
    //             paymentFrom,
    //             paymentTo,
    //             price
    //         }])

    //         setVolumeFrom("");
    //         setVolumeTo("");
    //         setDeliverFrom("");
    //         setDeliverTo("");
    //         setPaymentFrom("");
    //         setPaymentTo("");
    //         setPrice("");
    //     }
    // }

    const sendFormHandle = () => {
        setPriceErr("");
        setFeeErr("");
        setDiscountErr("");
        setFeedCoinErr("");

        let hasErr = false;

        if (price.trim() === "") {
            setPriceErr("لطفا قیمت را وارد کنید");
            hasErr = true;
        } else if (!Number.isInteger(price.trim() * 1)) {
            setPriceErr("قیمت وارد شده نامعتبر است");
            hasErr = true;
        }

        if (discount.trim() !== "" && !Number.isInteger(discount.trim() * 1)) {
            setDiscountErr("درصد تخفیف وارد شده نامعتبر است");
            hasErr = true;
        }

        if (feedCoin.trim() === "") {
            setFeedCoinErr("لطفا تعداد سکه را وارد کنید");
            hasErr = true;
        } else if (!Number.isInteger(feedCoin.trim() * 1)) {
            setFeedCoinErr("مقدار وارد شده نامعتبر است");
            hasErr = true;
        }

        if (hasErr) return false;

        setFormLoader(true);
        if (item) {
            post(CREATE_FOOD, {
                item,
                company: window.sessionStorage.getItem("usercompany"),
                coin: feedCoin * 1,
                price,
                active: true,
                discount: discount || 0,
            })
                .then((r) => {
                    history("/dashboard/sales/2");
                })
                .catch((e) => {
                    if (
                        e.response.data.non_field_errors[0] ===
                        "The fields item, company must make a unique set."
                    ) {
                        show("این آیتم قبلا ثبت شده است", "danger");
                    }
                })
                .finally((_) => {
                    setFormLoader(false);
                });
        } else {
            patch(EDIT_FOOD.replace(":id", id), {
                item: editItem,
                company: window.sessionStorage.getItem("usercompany"),
                coin: feedCoin * 1,
                price,
                active: true,
                discount,
            })
                .then((r) => {
                    history("/dashboard/sales/2");
                })
                .finally((_) => {
                    setFormLoader(false);
                });
        }
    };

    return (
        <div className="market-main">
            <MainPanelHeader panelType={"پنل سازمانی"} panelName={"سبد فروش"} />
            <div className="market-content">
                <PanelRightContent>
                    <div className="title">
                        <MarketIcon /> <span>قیمت گذاری</span>
                    </div>
                    {loader ? (
                        <div className="loader-spinner">
                            <Spinner animation="border" />
                        </div>
                    ) : (
                        <div className="basket-form">
                            <div>
                                <BasketInput
                                    title={"قیمت"}
                                    error={priceErr}
                                    value={price}
                                    onChange={(e) => setPrice(e)}
                                    icon={<DateIcon />}
                                    clearErr={(_) => setPriceErr("")}
                                />
                                <BasketInput
                                    title={"درصد تخفیف"}
                                    error={discountErr}
                                    value={discount}
                                    onChange={(e) => setDiscount(e)}
                                    icon={<CubeIcon />}
                                    clearErr={(_) => setDiscountErr("")}
                                />
                                {/* <BasketInput 
                            title={'درصد ارزش افزوده'}
                            error={feeErr}
                            value={fee}
                            onChange={(e)=>setFee(e)}
                            icon={<DateIcon />}
                            clearErr={_=>setFeeErr("")}

                        /> */}
                                <BasketInput
                                    title={"تعداد فیدکوین"}
                                    error={feedCoinErr}
                                    value={feedCoin}
                                    onChange={(e) => setFeedCoin(e)}
                                    icon={<CoinIcon />}
                                    clearErr={(_) => setFeedCoinErr("")}
                                />{" "}
                                <div>&nbsp;</div>
                                {/* <button className="toolbar-btn-primary" onClick={priceListHandle}>
                            {
                                priceListEditMode !== false ? <EditIcon /> : <PlusIcon />
                            }
                            
                        </button> */}
                                <div className="button-group">
                                    <button
                                        className="button primary"
                                        onClick={sendFormHandle}
                                    >
                                        {formLoader && (
                                            <div className="spinner-border-con">
                                                <Spinner animation="border" />
                                            </div>
                                        )}
                                        {!formLoader && (
                                            <div>{item ? "ثبت" : "ویرایش"}</div>
                                        )}
                                    </button>
                                    <button
                                        className="button delete"
                                        onClick={(_) =>
                                            history("/dashboard/sales/2")
                                        }
                                    >
                                        انصراف{" "}
                                    </button>
                                </div>
                            </div>
                            {itemBox && (
                                <div>
                                    <ItemCart
                                        link={itemBox?.id}
                                        score={itemBox?.computed_score}
                                        description={itemBox?.description}
                                        fullDescritpion={true}
                                        name={itemBox?.name}
                                        photo={itemBox?.photo}
                                        priceMin={itemBox?.price_min}
                                        priceMax={itemBox?.price_max}
                                        salersCount={itemBox?.salers_count}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </PanelRightContent>
            </div>
        </div>
    );
}
